import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Avatar } from './Avatar';
import { Ic } from './Icon';
import { useAuth } from '../store/auth';

interface TopBarProps {
  title: string;
  subtitle?: string;
  right?: ReactNode;
  back?: { to: string; label?: string };
}

export function TopBar({ title, subtitle, right, back }: TopBarProps) {
  const user = useAuth((s) => s.user);

  return (
    <header
      style={{
        minHeight: 72,
        borderBottom: '1px solid rgba(15,30,61,.06)',
        background: '#fff',
        display: 'flex',
        alignItems: 'center',
        padding: '12px 28px',
        gap: 20,
        flexShrink: 0,
        flexWrap: 'wrap',
      }}
    >
      {back && (
        <Link
          to={back.to}
          aria-label={back.label ?? 'Wróć'}
          title={back.label ?? 'Wróć'}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 36,
            height: 36,
            borderRadius: 10,
            background: 'rgba(15,30,61,.05)',
            color: '#0f1e3d',
            flexShrink: 0,
          }}
        >
          <Ic.chevL size={18} />
        </Link>
      )}
      <div style={{ flex: 1, minWidth: 200 }}>
        <div className="serif" style={{ fontSize: 22, fontWeight: 700, letterSpacing: '-0.01em' }}>
          {title}
        </div>
        {subtitle && (
          <div style={{ fontSize: 13, color: '#5b6578', marginTop: 2 }}>{subtitle}</div>
        )}
      </div>
      {right}
      {user && (
        <div title={user.nick} aria-label={user.nick} style={{ flexShrink: 0 }}>
          <Avatar nick={user.nick} size={34} />
        </div>
      )}
    </header>
  );
}
